export const homeDisplayTitles = {
  homeDisplaySportsTitle: "运动博彩",
  homeDisplaySportsSubtitle: "在世界顶级联赛中玩",
  homeDisplayContestChallengeTitle: "竞赛 -挑战从远处",
  homeDisplayTopGamesTitle: "10 最受欢迎!",
  homeDisplayAllBtn: "查看全部",
  homeDisplayLoginBtn: "登录",
  homeDisplayRegisterBtn: "注册",
  homeDisplayLiveGames: "直播游戏",
  homeDisplayFootball: "足球",
  homeDisplayTennis: "网球",
  homeDisplayBasketball: "篮球",
  homeDisplayVolleyball: "排球",
  homeDisplayEventRules: "赛事规则",

  homeDisplayModalTitle: "活动",
  homeDisplayModalClose: "关闭",
};
